import React from 'react';
import MatchedListingsTable from './matched_listings_table';
import { connect } from 'react-redux';
import UnmatchedListingsTables from './unmatched_listings_tables';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';

type LayoutProps = {
  unmatchedListingCount: number;
}

function Layout({ unmatchedListingCount } : LayoutProps) {
  const currentUrl = new URL(window.location.href);
  const zipUrl = `${currentUrl.origin}${currentUrl.pathname}.zip${currentUrl.search}`;

  return (
    <div className="p-2">
      <div className="text-end">
        <a className="btn btn-link btn-lg text-primary" href={zipUrl}>
          <FontAwesomeIcon icon={faDownload} />
        </a>
      </div>
      <MatchedListingsTable />
      <UnmatchedListingsTables count={unmatchedListingCount}/>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  unmatchedListingCount: (
    state.listings.unmatchedBuildoutListings.length + state.listings.unmatchedAnywhereListings.length
  )
});

export default connect(mapStateToProps)(Layout);
